import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-usage-skeleton',
  templateUrl: './usage-skeleton.component.html',
  styleUrls: ['./usage-skeleton.component.scss'],
  standalone: false
})
export class UsageSkeletonComponent {
  @Input() cards = 6;

  get placeholders(): number[] {
    const count = Math.max(1, Math.min(12, this.cards));
    return Array.from({ length: count }, (_, i) => i);
  }
}
